/** Format a number as Botswana Pula, e.g. 550 → "P 550.00". */
export function formatPula(amount: number): string {
  const n = Number.isFinite(amount) ? amount : 0;
  return `P ${n.toLocaleString('en-BW', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}
